<template>
<div>
  <el-table :data="userList">
    <el-table-column width="160px" label="注册时间">
      <template slot-scope="scope">
        {{scope.row.createTime | moment}}
      </template>
    </el-table-column>
    <el-table-column width="100px" prop="__registerFrom" label="注册来源"></el-table-column>
    <el-table-column prop="id" label="账号ID"/>
<!--    <el-table-column prop="contractUserId" label="合约用户ID"/>-->
    <el-table-column prop="tel" label="手机号"/>
    <el-table-column prop="email" label="邮箱"/>
    <el-table-column prop="inviteCode" label="邀请码"/>
    <el-table-column prop="inviteCount" label="邀请用户数">
      <template slot-scope="scope">
        <a class="account-link" @click="getUserDetail(scope.row,scope.row.id)">{{ scope.row.inviteCount }}</a>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="用户状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__userStatus.color">
          {{scope.row.__userStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="120px" label="实名认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__idNoStatus.color">
          {{scope.row.__idNoStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="邮箱认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__emailSecurityStatus.color">
          {{scope.row.__emailSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="手机认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__phoneSecurityStatus.color">
          {{scope.row.__phoneSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="Google认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__googleSecurityStatus.color">
          {{scope.row.__googleSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="120px" label="银行卡绑定状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__bankAuthStatus.color">
          {{scope.row.__bankAuthStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
<!--    <el-table-column width="100px" label="是否志愿者">-->
<!--      <template slot-scope="scope">-->
<!--        <el-tag :type="scope.row.__userVolunteerStatus.color">-->
<!--          {{scope.row.__userVolunteerStatus.text}}-->
<!--        </el-tag>-->
<!--      </template>-->
<!--    </el-table-column>-->
    <el-table-column width="100px" label="是否冻结">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__userBlockingStatus.color">
          {{scope.row.__userBlockingStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="200px">
      <template slot-scope="scope">
         <el-button size="small" type="danger" @click="handleUnBindSub(scope.row.id, subType, queryType, queryValue)">解绑</el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged"></pagination>

  <!-- 弹窗部分 -->
  <el-dialog title="添加绑定子账号" :visible.sync="addBindSubDialogVisible" width="30%">
    <el-form :model="addBindSubForm" :rules="addBindSubRules" ref="addBindSubForm" label-width="100px">
      <el-form-item label="主账号类型" prop="mainType">
        <el-select v-model="addBindSubForm.mainType" placeholder="请选择">
          <el-option
              v-for="item in queryTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主账号值" prop="mainValue">
        <el-input v-model="addBindSubForm.mainValue"></el-input>
      </el-form-item>
      <el-form-item label="子账号类型" prop="subType">
        <el-select v-model="addBindSubForm.subType" placeholder="请选择">
          <el-option
              v-for="item in queryTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子账号值" prop="subValue">
        <el-input v-model="addBindSubForm.subValue"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeAddBindSubDialog">取 消</el-button>
      <el-button type="primary" @click="submitAddBindSub">确 定</el-button>
    </span>
  </el-dialog>


  <el-dialog title="邀请详情" :visible.sync="dialogVisibleShow" width="90%"
             :close-on-click-modal="false">

    <div>
      <div style="margin-top: 20px">
        <div style="float: left;width:200px">
             <span style="padding-right: 20px;">
            账户：</span>
          <sapn>{{showInfo.email}}</sapn>
        </div>
        <div style="float: left;width:300px;padding-left: 50px;">
           <span style="padding-right: 5px;">
            邀请总数：</span>
          <sapn>{{showInfo.inviteCount}}</sapn>
        </div>
        <div style="float: left;width:200px">
            <span style="padding-right: 20px;">
            邀请并升级VIP：</span>
          <span>{{showInfo.inviteVipCount}}</span>
        </div>
        <div >&nbsp;</div>
      </div>


      <div style="margin-top: 20px">
            <span style="padding-right: 20px;">
            邀请码：</span>
        <span>{{showInfo.inviteCode}}</span>
        &nbsp;&nbsp;&nbsp;
        <a class="account-link" @click="inviteDialog(showInfo.id,showInfo.inviteCode)">修改邀请码</a>
        <el-button  size="small" type="danger" style="float: right;"   @click="exportData(showInfo.id)">导出</el-button>
      </div>

      <div style="">&nbsp;</div>
      <div style="">&nbsp;</div>
      <div style="">&nbsp;</div>

    </div>
    <el-table :data="dataListUser" ref="multipleTable" >
      <el-table-column  label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="email" label="账户"/>
      <el-table-column prop="address" label="钱包地址"/>
      <el-table-column prop="kycStatus" label="KYC状态">
        <template slot-scope="scope">
          {{ scope.row.kycStatus === false ? "未KYC" : "已KYC" }}
        </template>
      </el-table-column>
      <el-table-column prop="googleAuthStatus" label="google验证码">
        <template slot-scope="scope">
          {{ scope.row.googleAuthStatus === 0 || scope.row.googleAuthStatus == null ? "未开通" : "已开通" }}
        </template>
      </el-table-column>
      <el-table-column prop="vipLevel" label="VIP等级"/>
      <el-table-column prop="createTime" label="注册时间">
      <template slot-scope="scope">{{ scope.row.createTime | moment }}</template>
      </el-table-column>
      <el-table-column prop="vipTime" label="开通VIP时间">
        <template slot-scope="scope">{{ scope.row.vipTime | moment }}</template>

      </el-table-column>

    </el-table>
  </el-dialog>


  <el-dialog title="修改邀请码" :visible.sync="dialogCodeVisibleEdit" :append-to-body="true" width="40%"
             :close-on-click-modal="false">
    <div>
      <div style="margin-top: 20px">
          <span style="padding-right: 20px">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            新邀请码</span>
        <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength =8
                  v-model="inviteCode">
          &nbsp;
        </el-input>
        <div style="margin-top: 20px">
          <span><i style="color: #f56c6c;margin-right: 1px;">邀请码位数为8位数字+字母组成，不可有数字1,0，字母L,I,O</i></span>
        </div>

      </div>
    </div>
    <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="modifyInviteCode">确 定</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </span>
  </el-dialog>

</div>


</template>


<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import Pagination from 'components/pagination';
import api from '../../api'

export default {
  name: 'UserSubList',
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('userSub', ['userList']),
    ...mapState('userSub', ['pagination', 'totalCount', 'subType', 'subTypeList', 'queryType', 'queryTypeList', 'queryValue'])
  },
  data() {
    return {
      addBindSubDialogVisible: false,
      addBindSubForm: {
        mainType: '',
        mainValue: '',
        subType: '',
        subValue: ''
      },
      addBindSubRules: {
        mainType: [
          { required: true, message: '请选择主账号类型', trigger: 'change' }
        ],
        mainValue: [
          { required: true, message: '请输入主账号值', trigger: 'blur' }
        ],
        subType: [
          { required: true, message: '请选择子账号类型', trigger: 'change' }
        ],
        subValue: [
          { required: true, message: '请输入子账号值', trigger: 'blur' }
        ]
      },
      dialogVisibleShow: false,
      dataListUser: [],
      showInfo: {},
      dialogCodeVisibleEdit: false,
      inviteCode: '',
      userId: ''
    };
  },
  methods: {
    ...mapActions('userSub', ['unBindSub', 'addBindSub']),
    ...mapMutations('userSub', ['setQueryType', 'setSubType']),
    closeAddBindSubDialog() {
      this.addBindSubDialogVisible = false;
      this.addBindSubForm = {
        mainType: '',
        mainValue: '',
        subType: '',
        subValue: ''
      };
    },
    submitAddBindSub() {
      this.$refs.addBindSubForm.validate(valid => {
        if (!valid) return;
        // 这里应该添加提交绑定子账号的逻辑
        api.addBindSub(this.addBindSubForm).then(res => {
          this.$message.success('添加绑定成功');
          this.closeAddBindSubDialog();
          this.$emit('refresh'); // 刷新列表
        }).catch(err => {
          this.$message.error(err.message || '添加绑定失败');
        });
      });
    },
    handleUnBindSub(id, subType, queryType, queryValue) {
      const message = '确认将此用户解绑吗？';
      this.$confirm(message, '提示', {
        type: 'warning'
      }).then(() => {
        this.unBindSub({
          id, subType, queryType, queryValue
        }).then(() => {
          this.$message.success('解绑成功！');
          this.$emit('refresh');
        });
      });
    },
    closeDialog() {
      this.dialogCodeVisibleEdit = false;
      this.inviteCode = "";
    },
    inviteDialog(userid,inviteCode){
      this.dialogCodeVisibleEdit = true
      this.userId = userid;
      this.inviteCode = inviteCode
    },
    exportData(userId){
        api.export({
            userId
        }).then(response => {
            const fileName = "邀请详情" + this.userId+ ".xlsx";
            const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
            if ('download' in document.createElement('a')) {
                const link = document.createElement('a');
                link.download = fileName;
                link.style.display = 'none';
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                navigator.msSaveBlob(blob, fileName);
            }
        })
    },
    modifyInviteCode(){
      let userId1 = this.userId;
      let inviteCode1 = this.inviteCode
      inviteCode1 = inviteCode1.toUpperCase();
      //L,i,O
      if(inviteCode1.includes("1") || inviteCode1.includes("0")
              || inviteCode1.includes("L")  ||inviteCode1.includes("I") ||inviteCode1.includes("O") || inviteCode1.length !=8){
        this.$message.error('请按格式填写邀请码！');
        return;
      }
      api.updateInviteCode({
        userId1,inviteCode1
      }).then(res => {
        this.showInfo.inviteCode = inviteCode1
        this.dialogCodeVisibleEdit = false;
        this.$emit('refresh');
      })
    },
    getUserDetail(rowdata,userId) {
      this.showInfo = rowdata;
      api.getUserDetail1({
        userId
      }).then(res => {
        this.dialogVisibleShow = true;
        this.dataListUser = res.data;
      })
      this.detailDialogVisible = true;
    },

    // 添加分页变化处理方法
    pageChanged(page) {
      // 确保 pagination 对象正确更新
      this.$store.commit('userSub/setPagination', page); // 更新 store 中的 pagination
      this.$emit('refresh', {
        page: page.page, // 确保传递正确的 page 参数
        size: page.size  // 确保传递正确的 size 参数
      });
    },
    triggerShowAddBindDialog() {
      this.$emit('show-add-dialog');
    }
  }
};
</script>

<style lang="less" scoped>
  @import url("~styles/variables.less");

  .account-link,
  .network-link {
    color: @color-primary;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
